module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Banshee-S1.00d43b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Banshee-S1.jpg
// module id = SfSr
// module chunks = 0